import { AxiosError } from 'axios';
import { AXIOS_RETRIES_LEFT_HEADER_NAME } from '@vsf-enterprise/sapcc-api';

export const getRetriesLeft = (error: AxiosError): number => {
  const failedRequestHeaders = error.config.headers;
  const retriesHeader = failedRequestHeaders[AXIOS_RETRIES_LEFT_HEADER_NAME];

  return Number(retriesHeader ?? 3);
};
